<template>
  <involved-intro />
  <ways-to-help />
  <ask-as />
</template>

<script>
import InvolvedIntro from "@/components/GetInvolvedDir/InvolvedIntro.vue";
import WaysToHelp from "@/components/GetInvolvedDir/WaysToHelp.vue";
import AskAs from "@/components/AskAs.vue";

export default {
  components: {
    InvolvedIntro,
    WaysToHelp,
    AskAs,
  },
  name: "GetInvolvedHero",
};
</script>

<style></style>
